export const initialState = {
  menuOpen: false,
};

export function reducer(state, action) {
  const { type } = action;

  switch (type) {
    case 'toggleMenu':
      return { ...state, menuOpen: !state.menuOpen };
    default:
      throw new Error();
  }
}
